<script>
  import { MonsterStore, SetupStore } from "../stores/gameStore";
  import MonsterCard from "./MonsterCard.svelte";

  export let width = 600;

  let monsterClass1 = 'M3';
  $: if ($MonsterStore?.class1 == 'EMPTY') {
        monsterClass1 = 'M3';
      } else {
        monsterClass1 = $MonsterStore?.class1;
      }

  let monsterClass2 = 'M13';
  $: if ($MonsterStore?.class2 == 'EMPTY') {
        monsterClass2 = 'M13';
      } else {
        monsterClass2 = $MonsterStore?.class2;
      }

  let monsterClass3 = 'M23';
  $: if ($MonsterStore?.class3 == 'EMPTY') {
        monsterClass3 = 'M23';
      } else {
        monsterClass3 = $MonsterStore?.class3;
      }    
</script>

<div class="wrapper shadow-md" style:width="{width}px">
  <div class="slot" style:top="17.8%" style:left="2.18%">
      {#key monsterClass1}
        <MonsterCard
          width={width / 4.6}
          card={monsterClass1 &&
            $SetupStore.data.cards[monsterClass1]}
          id={monsterClass1}
        />
      {/key}
  </div>
  <div class="slot" style:top="17.8%" style:left="26.12%">
      {#key monsterClass2}
        <MonsterCard
          width={width / 4.6}
          card={monsterClass2 &&
            $SetupStore.data.cards[monsterClass2]}
          id={monsterClass2}
        />
      {/key}
  </div>
  <div class="slot" style:top="17.8%" style:left="50%">
      {#key monsterClass3}
        <MonsterCard
          width={width / 4.6}
          card={monsterClass3 &&
            $SetupStore.data.cards[monsterClass3]}
          id={monsterClass3}
        />
      {/key}
  </div>
  <div class="slot" style:top="5.1%" style:left="76%">
    <MonsterCard
      width={width / 4.6}
      card={$SetupStore?.selectedKing &&
        $SetupStore.data.cards[$SetupStore.selectedKing]}
      id={$SetupStore.selectedKing}
    />
  </div>

  <div class="monster-number monster-number-1">{$MonsterStore?.class1_amount}</div>
  <div class="monster-number monster-number-2">{$MonsterStore?.class2_amount}</div>
  <div class="monster-number monster-number-3">{$MonsterStore?.class3_amount}</div>

  <div class="board" />
</div>

<style>
  .slot {
    position: absolute;
  }

  .monster-number {
    position: absolute;
    font-size: 20px;
    font-family: "Merriweather";
    font-weight: bold;
    color: rgb(0, 0, 0); /* Customize your text style */
    z-index: 10; /* Ensure the text is above the board */
  }

  /* Define positions for the three monster amounts */
  .monster-number-1 {
    top: 4%;
    left: 14.5%;
  }

  .monster-number-2 {
    top: 4%;
    left: 38%;;
  }

  .monster-number-3 {
    top: 4%;
    left: 62%;
  }
  .board {
    aspect-ratio: 1704/740;
    background-image: url("img/Monster-Board.jpg");
    background-size: contain;
  }

  .wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
  }
</style>
